module.exports = __webpack_public_path__ + "static/media/Instagram.9b277696.svg";